var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoctorRoleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "inherit",
    height: "inherit",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 391.108,
    height: 463.417
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Doctor"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 800
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Doctor",
    clipPath: "url(#clip-Doctor)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(204.214 168.791)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10755",
    "data-name": "Path 10755",
    d: "M346.434,296.461l-54.423-17.611a6.1,6.1,0,0,0-1.038-.338l-44.012-14.241v-29.35a94.781,94.781,0,0,0,39.7-54.113A30.043,30.043,0,0,0,302.488,131.2a30.944,30.944,0,0,0-2.525-2.473,30.094,30.094,0,0,0-7.694-4.859c5.257-13.951,10.576-34.85,6.438-55.835-4.923-24.966-21.9-44.047-50.452-56.713a132.145,132.145,0,0,0-73.939-9.729c-19.55,3.013-35.744,8.951-48.134,17.652C109.333,31.08,100.013,47.626,98.476,68.421c-.867,1.907-3.553,8.715-3.879,20.285a90.3,90.3,0,0,0,6.071,34.415,29.78,29.78,0,0,0-9.554,5.607,32.719,32.719,0,0,0-2.523,2.47,30.051,30.051,0,0,0,15.831,49.61,94.8,94.8,0,0,0,39.71,54.123v29.322l-49.755,16.1a6.109,6.109,0,0,0-.982.318l-48.5,15.7-.244.086A69.133,69.133,0,0,0,0,360.694v86.962a15.786,15.786,0,0,0,15.739,15.76H375.347a15.818,15.818,0,0,0,15.76-15.751V360.7a69.135,69.135,0,0,0-44.673-64.243M157.893,73.479a6.4,6.4,0,0,0-4.152,3.929c-7.7,21.178-29.746,32.421-42.473,37.305-7.954-24.448-1.424-40.42-1.175-41.027a6.386,6.386,0,0,0,1.067-3.186c2.2-38.559,36.617-51.888,65.107-56.28A119.285,119.285,0,0,1,243.068,23c24.514,10.873,39.034,27.07,43.155,48.142,3.635,18.584-1.64,37.6-6.757,50.364-55.03-2.523-115.329-46.611-115.933-47.057h0a6.367,6.367,0,0,0-3.787-1.241h0a6.35,6.35,0,0,0-1.848.275m-44.083,53.948c13.276-4.767,36.916-15.99,48.634-38.167,19.065,12.8,67.563,42.163,114.838,44.93v21.458a81.877,81.877,0,0,1-1.921,17.665,6.039,6.039,0,0,0-.224.977,82.575,82.575,0,0,1-36.886,51.034,6.117,6.117,0,0,0-1.756,1.043,81.311,81.311,0,0,1-40.848,11.017h-.2a81.351,81.351,0,0,1-40.421-10.771,6.4,6.4,0,0,0-2.632-1.575,81.276,81.276,0,0,1-38.584-69.392Zm43.11,114.486a93.282,93.282,0,0,0,38.512,8.257h.113a93.066,93.066,0,0,0,38.636-8.262V266.5l-38.636,44.579L156.92,266.5ZM112.36,371.856a16.523,16.523,0,1,1-33.045,0h0a16.523,16.523,0,0,1,33.046,0M89.425,343.2a29.361,29.361,0,1,0,12.828,0V291.254l46.218-14.963,42.242,48.756a6.388,6.388,0,0,0,4.828,2.208h.011a6.353,6.353,0,0,0,4.819-2.208l42.242-48.737,40.488,13.1v49.74a35.106,35.106,0,0,0-28.695,34.5v22.937A6.426,6.426,0,0,0,260.821,403h11.474a6.414,6.414,0,1,0,0-12.828h-5.05V373.651a22.26,22.26,0,0,1,44.52,0v16.523h-5.049a6.414,6.414,0,1,0,0,12.828h11.537a6.379,6.379,0,0,0,6.33-6.415V373.649a35.126,35.126,0,0,0-28.653-34.495v-45.6l46.177,14.938a56.249,56.249,0,0,1,36.206,52.21v86.963a2.973,2.973,0,0,1-2.952,2.973H15.742a2.972,2.972,0,0,1-2.954-2.974V360.706a56.247,56.247,0,0,1,36.2-52.208l40.44-13.09Zm200.643-206a17.314,17.314,0,0,1,1.5,1.164,19.956,19.956,0,0,1,1.494,1.463,17.075,17.075,0,0,1,4.488,11.6,17.274,17.274,0,0,1-8.048,14.612,95.321,95.321,0,0,0,.569-10.4ZM98.009,139.833A20.425,20.425,0,0,1,99.5,138.37a17.187,17.187,0,0,1,1.519-1.179v18.456a95.451,95.451,0,0,0,.571,10.42,17.276,17.276,0,0,1-3.584-26.234",
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    transform: "translate(1 1)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 17
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 399.5,
    cy: 399.5,
    r: 399.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.5,
    cy: 399.5,
    r: 391,
    fill: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorRoleIcon);
export default __webpack_public_path__ + "static/media/DoctorRoleIcon.9d39cadcfed9e4d363fdd519740670c1.svg";
export { ForwardRef as ReactComponent };